import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  menu: {
    minWidth: 160,
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  paper: {
    backgroundColor: theme.palette.otherElementsBackground.main,
  },
}));
